import React from "react";
import { FaSpinner, FaCheckCircle } from "react-icons/fa";

const ProgressModal = ({ isOpen, progreso, onClose }) => {
  if (!isOpen) return null;

  const porcentaje = progreso.total > 0 ? (progreso.actual / progreso.total) * 100 : 0;
  const completado = progreso.actual === progreso.total && progreso.total > 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="text-center">
          {/* Ícono */}
          <div className="mb-4">
            {completado ? (
              <FaCheckCircle className="text-6xl text-green-500 mx-auto" />
            ) : (
              <FaSpinner className="text-6xl text-blue-500 mx-auto animate-spin" />
            )}
          </div>

          {/* Título */}
          <h3 className="text-xl font-semibold mb-4">
            {completado ? "¡Generación Completada!" : "Generando Boletines Finales"}
          </h3>

          {/* Mensaje de progreso */}
          <p className="text-gray-600 mb-4">{progreso.mensaje}</p>

          {/* Barra de progreso */}
          <div className="mb-4">
            <div className="bg-gray-200 rounded-full h-4">
              <div
                className={`h-4 rounded-full transition-all duration-500 ${
                  completado ? 'bg-green-500' : 'bg-blue-500'
                }`}
                style={{ width: `${porcentaje}%` }}
              ></div>
            </div>
            <p className="text-sm text-gray-500 mt-2">
              {progreso.actual} de {progreso.total} boletines
            </p>
          </div>

          {/* Porcentaje */}
          <div className="text-3xl font-bold mb-6">
            <span className={completado ? 'text-green-500' : 'text-blue-500'}>
              {porcentaje.toFixed(1)}%
            </span>
          </div>

          {/* Botón cerrar (solo visible cuando está completado) */}
          {completado && (
            <button
              onClick={onClose}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Cerrar
            </button>
          )}

          {!completado && (
            <p className="text-sm text-gray-500">
              Por favor, no cierre esta ventana hasta que termine el proceso.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressModal;